export const ZEPHR_DECISIONS = {
  ONBOARDING_MARK_AS_SEEN: "onboarding-mark-as-seen",
  DOWNLOAD_ACTION_PAYWALL: "download-action-paywall",
} as const;

export const ZEPHR_FEATURES = {
  ONBOARDING_SHOW_MODAL: "onboarding-show-onboarding-modal",
  LOGIN_REGISTRATION_FORM: "login-registration-form",
  CHECKOUT_REGISTRATION_FORM: "checkout-registration-form",
  UPDATE_MISSING_INFO: "update-missing-info",
  COMPLETE_PROFILE_FORM: "complete-profile-form",
  COMPLETE_PROFILE_OPTIONAL_FORM: "complete-profile-optional",
  COMPLETE_PROFILE_PROMPT: "complete-profile-prompt",
  SHOW_BOTTOM_BANNER: "show-bottom-banner",
  SHOW_BOTTOM_BANNER_ALT: "show-bottom-banner-alt",
  PAYMENT_PANEL: "payment-panel",
  ACCOUNT_SETTINGS_PROFILE_DETAILS_FORM:
    "account-settings-profile-details-form",
  ACCOUNT_SETTINGS_NEWSLETTER_PREFERENCES_FORM:
    "account-settings-newsletter-preferences-form",
  ACCOUNT_SETTINGS_PAYMENT_DETAILS_FORM:
    "account-settings-payment-details-form",
} as const;

export type ZephrDecision =
  (typeof ZEPHR_DECISIONS)[keyof typeof ZEPHR_DECISIONS];
export type ZephrFeature = (typeof ZEPHR_FEATURES)[keyof typeof ZEPHR_FEATURES];

export const COMPLETE_PROFILE_SUBMITTED_MARKER =
  "complete_profile_submitted";

export const COMPLETE_PROFILE_DIALOG_ID = "complete-profile-dialog";

export const LOGIN_DIALOG_ID = "login-dialog";

export const ZEPHR_DIALOG_MARKER = "data-zephr-dialog";
